import PropTypes from 'prop-types'
import ActiveRecord from 'model/activeRecord'
import { isNil } from 'ramda'
import User from 'model/person/user'
import dayjs from 'dayjs'
import { getDateAndTimeFormat } from 'utils/helpers/dateHelper'

class ChatMessage extends ActiveRecord {
  constructor(init) {
    super(init)
    // console.log('> ChatMessage constructor -', init)
    if (isNil(init)) return undefined
    this._attachment = init.attachment
    this._attachments = init.attachments
    this._body = init.body
    this._chat_id = init.chat_id
    this._file = init.file
    this._receiver_read_at = init.receiver_read_at
    this._sender = new User(init.sender)
    this._subject = init.subject
  }

  static shape = {
    id: PropTypes.string.isRequired,
    attachment: PropTypes.object,
    attachments: PropTypes.arrayOf(
      PropTypes.shape({
        short_url: PropTypes.string,
        file_name: PropTypes.string,
        scan_status: PropTypes.string,
        content_type: PropTypes.string,
        size: PropTypes.number
      })
    ),
    body: PropTypes.string,
    chat_id: PropTypes.string.isRequired,
    file: PropTypes.object,
    receiver_read_at: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sender: PropTypes.instanceOf(User),
    subject: PropTypes.string
  }

  // Getters for class fields
  get attachment() {
    return this._attachment
  }

  get attachments() {
    return this._attachments
  }

  get body() {
    return this._body
  }

  get chat_id() {
    return this._chat_id
  }

  get file() {
    return this._file
  }

  get receiver_read_at() {
    return this._receiver_read_at
  }

  get sender() {
    return this._sender
  }

  get subject() {
    return this._subject
  }

  // Calculable
  get getSenderMemberId() {
    return this.sender?.member?.id || false
  }

  get getSenderFullName() {
    return this.sender?.full_name || ''
  }

  get getSenderIsEmployee() {
    return this.sender?.registration_status === 'member'
  }

  get getReadStatus() {
    if (this.receiver_read_at === -1) return 'Sent'
    if (this.receiver_read_at === null) return 'Delivered'

    return `Read ${getDateAndTimeFormat(this.receiver_read_at)}`
  }

  get getSentStatus() {
    return `Sent ${getDateAndTimeFormat(this.created_at)}`
  }
}

export default ChatMessage
